// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
/* tslint:disable */
export enum Type {
  PROPERTY_TYPE_STRING = 0,
  PROPERTY_TYPE_INT64 = 1,
  PROPERTY_TYPE_DOUBLE = 2,
  PROPERTY_TYPE_BOOL = 3,
  PROPERTY_TYPE_TIMESTAMP = 4,
  PROPERTY_TYPE_GEOPOINT = 5,
  PROPERTY_TYPE_STRUCT = 6,
  PROPERTY_TYPE_BYTES = 7,
}
